(() => {
  const sectionSelector = 'body.template-page-press section-press-carousel';
  const readyAttribute = 'data-press-quote-fit-ready';

  const fitCarousel = (section) => {
    const swiper = section && (
      section.carouselInstance ||
      section.querySelector('[data-press-carousel]')?.swiper
    );

    if (!swiper || swiper.destroyed) return false;

    swiper.params.autoHeight = true;

    if (swiper.originalParams) {
      swiper.originalParams.autoHeight = true;
    }

    if (swiper.params.breakpoints && swiper.params.breakpoints[768]) {
      swiper.params.breakpoints[768].autoHeight = true;
    }

    if (swiper.originalParams && swiper.originalParams.breakpoints && swiper.originalParams.breakpoints[768]) {
      swiper.originalParams.breakpoints[768].autoHeight = true;
    }

    swiper.update();
    swiper.updateAutoHeight(0);

    return true;
  };

  const scheduleFit = (section) => {
    window.requestAnimationFrame(() => fitCarousel(section));
  };

  const initSection = (section, attempts = 0) => {
    if (!section) return;

    if (!fitCarousel(section)) {
      if (attempts < 12) {
        window.setTimeout(() => initSection(section, attempts + 1), 100);
      }

      return;
    }

    if (section.getAttribute(readyAttribute) === 'true') return;

    const swiper = section.carouselInstance || section.querySelector('[data-press-carousel]')?.swiper;

    swiper.on('breakpoint', () => scheduleFit(section));
    swiper.on('slideChange', () => scheduleFit(section));
    swiper.on('transitionEnd', () => scheduleFit(section));
    window.addEventListener('resize', () => scheduleFit(section));

    section.setAttribute(readyAttribute, 'true');
  };

  const initAll = () => {
    document.querySelectorAll(sectionSelector).forEach((section) => initSection(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.customElements.whenDefined('section-press-carousel').then(initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target && event.target.matches('section-press-carousel')
      ? event.target
      : event.target && event.target.querySelector('section-press-carousel');

    initSection(section);
  });
})();
